<template>
  <page-outline :title="$t('bank_accounts.add_bank_account')">
    <template slot="pageContent">
      <b-row class="m-0 pb-3 no-gutters">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <b-container>
        <b-row class="justify-content-center">
          <b-col class="form-group" md="7" cols="11">
            <form-write-group-label-input horizontal v-model="name" isMandatory
              :colInputSize="9"
              inputType="text"
              :inputLabel="$t('common.nme')"
              :placeholderValue="$t('bank_accounts.bank_account_name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col class="form-group" md="7" cols="12">
            <form-write-group-label-input isMandatory horizontal
              :colInputSize="7"
              inputType="listeSelect"
              inputClass="pr-4"
              :inputLabel="$t('common.account_zone')">
              <select class="form-control h-30px mw-100 pr-4" id="sel4" readonly v-model="zone">
                <option v-for="country in countries" :key="country.id"
                  :value="country"
                  :disabled="country.disabled"
                  :selected="country.selected">
                  {{ $t('zoneCodes.' + country.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-center" v-for="accountLabel in zone.accountLabel" :key="accountLabel">
          <b-col class="form-group" md="7" cols="12">
            <form-write-group-label-input v-model="zone.values[accountLabel]" isMandatory horizontal
              :colInputSize="9"
              inputType="text"
              :inputLabel="$t(accountLabel)"
              :placeholderValue="$i18n.t(accountLabel)">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </b-container>
      <b-row class="accordionForm mt-3 justify-content-end no-gutters">
        <b-button variant="primary"
          @click="addAccount()">
          <i class="fa-light fa-floppy-disk"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>


<script>
import _ from 'lodash'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'

import {createForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat, validateIBAN, validateIBANRIBKey} from '@/helpers/validator'

export default {
  name: 'AddBankAccount',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      name: '',
      zone: {
        id: 0,
        label: this.$t('zoneCodes.slct_zone'),
        disabled: true,
        selected: true
      },
      zoneCode: '',
      countries: '',
      countryPicker: '',
      returnUrl: '/bankAccounts/'
    }
  },
  created () {
    // DEFAULT
    // this.zone = 'EU'
    let that = this
    let label = []

    that.countries = _.cloneDeep(this.$engine.bankAccounts.getZoneCode())
    that.countries.forEach((x, y) => {
      label.push(this.$t('zoneCodes.' + x.label))
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = _.cloneDeep(that.$engine.bankAccounts.getZoneData(p.value[0]))
      }
    })
  },
  methods: {
    addAccount () {
      let that = this

      // Check input formats
      const regexName = /^[\p{L}\p{N}\p{M}][\p{L}\p{N}\p{M}\s'-]*$/u
      if (this.name === '') {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.nme')}))
        return
      }
      if (!regexName.test(this.name)) {
        this.$f7.alert(
            this.$i18n.t('errors.change_to_valid',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.invalid_data_format',
              {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      if (this.zone.accountNumberField == null) {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.account_zone')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.account_zone')})
        )
      }
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.accountLabel && this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        } else {
          // Account zone is mandatory
          this.$f7.alert(
              this.$i18n.t('errors.please_enter_mandatory',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
              this.$i18n.t('errors.missing_label',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
          )
          return
        }
      }

      let ibanValue
      if(this.zone.label === 'EUR') {
        ibanValue = this.zone.values['common.ibn']
      }
      if (validateIBAN(ibanValue) === false || validateIBANRIBKey(ibanValue) === false) {
        this.$f7.alert(
          this.$i18n.t('errors.chng_the_iban_to_vld_frmt'),
          this.$i18n.t('errors.invalid_data_format', {
            invaliddata: this.$i18n.t('contacts.ibn'),
          })
        )
        return
      }

      // Format IBAN
      let localIban = createForeignIban(this.zone)

      // Create account
      this.$engine.bankAccounts
        .create({
          name: this.name,
          iban: localIban,
          zoneCode: this.zone.label
        })
        .then(resp => {
          this.$f7.modal({
            title: this.$i18n.t('success.added_success', {data: this.$i18n.t('common.act')}),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.iban = ''
            that.name = ''
            that.zone = 'EU'
            that.sortCode = ''
            that.accountNumber = ''
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>
